import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	OnInit,
	signal,
	WritableSignal,
} from '@angular/core';
import {
	FormArray,
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IChecklistOption } from '@app/domain/types';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'add-checklist-item-dialog',
	imports: [
		MatFormFieldModule,
		MatInputModule,
		NgxTolgeeModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		MatDialogClose,
	],
	templateUrl: './add-checklist-item-dialog.component.html',
	styleUrl: './add-checklist-item-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddChecklistItemDialogComponent implements OnInit {
	private readonly dialogData = inject(MAT_DIALOG_DATA) as IChecklistOption[];
	itemsToAddControl = new FormControl<number>(1);

	checklistForm = new FormGroup({
		items: new FormArray<FormControl<string>>([]),
	});

	itemsArray = computed((): FormArray<FormControl<string>> => {
		return this.checklistForm.get('items') as FormArray<FormControl<string>>;
	});

	itemsToAdd: WritableSignal<string[]> = signal<string[]>(['']);
	ngOnInit() {
		this.itemsToAddControl.setValue(this.dialogData?.length || 1);
		this.addChecklistItemsToList();
	}

	addChecklistItemsToList() {
		this.itemsArray().clear();
		const amount = this.itemsToAddControl.value;

		if (!amount || amount < 1) return;

		for (let i = 0; i < amount; i++) {
			this.itemsArray().push(new FormControl(this.dialogData[i]?.question || ''));
		}
	}
}
